import { createContext, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router';
import { ArrowLeft } from 'lucide-react';

export interface Crumb {
  label: string;
  to?: string;
}

const Ctx = createContext<{ crumbs: Crumb[]; setCrumbs: (c: Crumb[]) => void }>({ crumbs: [], setCrumbs: () => {} });

export function BreadcrumbProvider({ children }: { children: React.ReactNode }) {
  const [crumbs, setCrumbs] = useState<Crumb[]>([]);
  return <Ctx.Provider value={{ crumbs, setCrumbs }}>{children}</Ctx.Provider>;
}

/** Define a trilha da página (formato Instituição > Trabalho > Seção). */
// eslint-disable-next-line react-refresh/only-export-components -- hook do provider definido neste módulo
export function useBreadcrumbs(crumbs: Crumb[]) {
  const { setCrumbs } = useContext(Ctx);
  const key = JSON.stringify(crumbs);
  useEffect(() => {
    setCrumbs(JSON.parse(key) as Crumb[]);
  }, [key, setCrumbs]);
}

/**
 * Volta um nível, como o "← Eventos" do votaDCR: um link na cor principal para o nível acima (o último da
 * trilha com endereço). O nome da página já está no título, então a trilha completa não aparece.
 */
export function Breadcrumbs() {
  const { crumbs } = useContext(Ctx);
  const parent = crumbs.length > 1 ? crumbs.slice(0, -1).findLast((c) => c.to) : undefined;
  if (!parent?.to) return null;
  return (
    <nav aria-label="Voltar" className="min-w-0">
      <Link to={parent.to} className="text-primary inline-flex max-w-full items-center gap-1.5 font-medium underline-offset-4 hover:underline">
        <ArrowLeft className="size-4 shrink-0" aria-hidden />
        <span className="truncate">{parent.label}</span>
      </Link>
    </nav>
  );
}
